import SizeHelpers from '../common/size-helpers';

const allPhotos = sizes => {
  return SizeHelpers.augment.fromCollection(sizes);
};

const photoRootIds = (sizes, fromPhotoCollecton = false) => {
  const photos = fromPhotoCollecton ? sizes : allPhotos(sizes);

  return photos.reduce((acc, photo) => {
    if (photo.image_id && acc.indexOf(photo.root_image_id) === -1) {
      acc.push(photo.root_image_id);
    }

    return acc;
  }, []);
};

export default photoRootIds;
